module.exports = __webpack_public_path__ + "static/media/more.146b9654.png";